import React, { FC } from 'react';
import { ThemeLayout } from './ThemeLayout';
import Image from '@/src/components/Image';
import Typography from '@/src/components/ui/typography';
import { useLocale } from 'next-intl';
import { ChevronRight } from 'lucide-react';
import Container from '@/src/components/ui/container';
import { cn } from '@/src/lib/utils/command';
import { DestinationTypes, IPromotedBanner } from '../services/types';
import RenderDestination from './RenderDestination';

type Props = {
  data: IPromotedBanner;
  name: string;
  branchId?: number;
};

export const PromoBanner: FC<Props> = ({ data, name, branchId }) => {
  const { ArabicImage, Destination, EnglishImage } = data;
  const locale = useLocale();
  const image = locale === 'ar' ? ArabicImage : EnglishImage;
  return (
    <Container className="lg:hidden">
      <RenderDestination destination={Destination} branchId={branchId}>
        <section className="bg-promoted-banner pointer-none: mx-auto flex max-w-87.5 items-center justify-between rounded-full px-4">
          <Image
            src={image}
            alt=""
            width={60}
            height={60}
            className="size-12 rounded-full object-contain p-1"
          />

          {/* text */}

          <Typography component={'h2'} variant={'h6'} color={'white'}>
            {name}
          </Typography>

          {/* icon */}

          <ChevronRight
            className={cn(
              'text-white rtl:rotate-180',
              Destination?.DestinationType === DestinationTypes.NO_DESTINATION
                ? 'invisible'
                : 'visible',
            )}
          />
        </section>
      </RenderDestination>
    </Container>
  );
};
